import React from "react";
import { Card, Col, Row, Spinner } from "react-bootstrap";
import PrimaryButton from "../../components/PrimaryButton";
import FileUploadComponent from "../../components/FileUploadComponent";
import MessageList from "../../components/MessageList";
import usePulloutLetterNamesViewController from "../../viewControllers/PulloutLetterNamesViewController";
import i18n from "../../constants/Strings";

const PulloutLetterNames = () => {

  const {
    goBack,
    setSelectedFile,
    saveStatus,
    uploadFile,
    messages,
    loading,
    selectedFile,
    setFileName,
    fileName
  } = usePulloutLetterNamesViewController();

  const text = {
    pageHeading: i18n.t('pulloutLetterNames.pageHeading'),
    backBtn: i18n.t('pulloutLetterNames.backBtn'),
    saveBtn: i18n.t('pulloutLetterNames.saveBtn'),
  }

  return (
    <>

      <nav className="navbar navbar-expand navbar-light bg-white topbar mb-4 static-top shadow"></nav>
      <div className="container-fluid">
        <h6 className="back-btn" onClick={goBack}>{text.backBtn}</h6>
        <div className=" mb-4">
          <div className="card-header py-3">
            <h6 className="m-0 font-weight-bold txt-primary">
              {text.pageHeading}
            </h6>
          </div>

          <Card style={{ width: "100%", height: "500px" }}>
            <Row className="mt-5 ">
              <Row>
                <div className="d-flex justify-content-center">
                  <div className="px-4 w-50">
                  <FileUploadComponent
                    key={selectedFile ? selectedFile.name : ""}
                    setSelectedFile={setSelectedFile}
                    setFileName={setFileName}
                    fileName={fileName}
                    fileType={".csv"}
                  />
                  </div>
                  <div>
                    {loading ? <Spinner /> : (
                      <PrimaryButton
                        disabled={saveStatus}
                        type="submit"
                        text={text.saveBtn}
                        className="width-auto  "
                        onClick={uploadFile}
                      />
                    )}

                  </div>
                </div>
              </Row>
              <Row className="px-4 ">
                <Col className="d-flex justify-content-center mt-3">
                  <MessageList messages={messages} textColor={"red"} />
                </Col>
              </Row>
            </Row>
          </Card>
        </div>
      </div>
    </>
  );
};

export default PulloutLetterNames;
